import { useCallback } from "react";

const SESSION_KEY = (slug) => `pixandgo_session_${slug}`;

function usePixAndGoSession(merchantSlug) {
  const save = useCallback(
    (data) => {
      localStorage.setItem(SESSION_KEY(merchantSlug), JSON.stringify(data));
    },
    [merchantSlug],
  );

  const get = useCallback(() => {
    try {
      const raw = localStorage.getItem(SESSION_KEY(merchantSlug));
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed.expiresAt && new Date(parsed.expiresAt) < new Date()) {
        localStorage.removeItem(SESSION_KEY(merchantSlug));
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  }, [merchantSlug]);

  const clear = useCallback(() => {
    if (!merchantSlug) return;
    localStorage.removeItem(SESSION_KEY(merchantSlug));
  }, [merchantSlug]);

  return { save, get, clear };
}

export default usePixAndGoSession;
